import { Archive, ExternalLink } from "lucide-react";

export const ArchiveTab = ({ archival }) => (
  <div className="space-y-8" data-testid="archive-rights-panel">
    <div className="border border-white/10 bg-[#121418] p-8">
      <div className="flex items-start gap-4">
        <Archive size={26} className="text-[#C5A059] mt-1 shrink-0" strokeWidth={1.5} />
        <div>
          <h3 className="font-serif text-2xl text-[#EBE9E1] mb-2">Digitization &amp; Rights</h3>
          <p className="text-[#8A8F98] text-sm max-w-3xl">
            These <strong className="text-[#C5A059]">{archival?.total ?? 0} records</strong> are catalogued but not yet streaming, so they are
            hidden from the public library. They are grouped below by the decision needed to bring each online.
          </p>
        </div>
      </div>
    </div>

    {!archival && <p className="text-[#8A8F98] text-sm px-2">Loading…</p>}
    {archival && archival.total === 0 && (
      <p className="text-[#8A8F98] text-sm px-2">Every record is currently streaming. Nothing pending digitization.</p>
    )}

    {archival?.groups?.map((g) => (
      <div key={g.decision} className="border border-white/10 bg-[#121418] p-8" data-testid={`archive-group-${g.decision.slice(0, 10)}`}>
        <div className="flex items-center justify-between gap-4 mb-5">
          <h4 className="font-serif text-xl text-[#EBE9E1]">{g.decision}</h4>
          <span className="text-[#C5A059] font-serif text-2xl shrink-0">{g.count}</span>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-[10px] tracking-widest uppercase text-[#8A8F98] border-b border-white/10">
                <th className="py-2 pr-4 font-medium">Title</th>
                <th className="py-2 pr-4 font-medium">Year</th>
                <th className="py-2 pr-4 font-medium">Platform</th>
                <th className="py-2 pr-4 font-medium">Source / Notes</th>
                <th className="py-2 font-medium">Link</th>
              </tr>
            </thead>
            <tbody>
              {g.items.map((it) => (
                <tr key={it.id} className="border-b border-white/5 text-[#EBE9E1] align-top">
                  <td className="py-3 pr-4">{it.title}</td>
                  <td className="py-3 pr-4 text-[#8A8F98] whitespace-nowrap">{it.year || "—"}</td>
                  <td className="py-3 pr-4 text-[#8A8F98] whitespace-nowrap">{it.platform || "—"}</td>
                  <td className="py-3 pr-4 text-[#8A8F98] max-w-md">{it.source || it.notes || "—"}</td>
                  <td className="py-3">
                    {it.url ? (
                      <a href={it.url} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-[#C5A059] hover:text-[#D6B570]">
                        Open <ExternalLink size={13} />
                      </a>
                    ) : "—"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    ))}
  </div>
);
